import { wishListCardStyles } from "@insite/content-library/Components/WishListCard";
import { createListButtonStyles } from "@insite/content-library/Widgets/MyLists/MyListsCreateListButton";
import { listStyles } from "@insite/content-library/Widgets/MyLists/MyListsList";
import { paginationStyles } from "@insite/content-library/Widgets/MyLists/MyListsPagination";
import { searchBoxStyles } from "@insite/content-library/Widgets/MyLists/MyListsSearchBox";
import { myListsDetailsOptionsStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListDetailsPagination";
import { headerStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsHeader";
import { productListStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsProductList";
import { productListFilterAccordionSectionStyles } from "@insite/content-library/Widgets/ProductList/ProductListFilterAccordionSection";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { GridOffset, GridWrapper } from "@insite/mobius/GridContainer";
import Search from "@insite/mobius/Icons/Search";
import { InputStyle } from "@insite/mobius/TextField";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

productListStyles.sortOrderTextField = {
    labelPosition: "top",
    labelProps: {
        size: 9,
        transform: "uppercase",
        css: css`
                min-height: auto;
                text-align: center;
            `,
    },
    cssOverrides: {
        formInputWrapper: css`
                input[type="number"]::-webkit-outer-spin-button,
                input[type="number"]::-webkit-inner-spin-button {
                    /* ISC-11023 deal with this. */
                    /* stylelint-disable-next-line */
                    -webkit-appearance: none;
                    margin: 0;
                }
            `,
        formField: css`
                margin-top: 10px;
            `,
        inputSelect: css`
                text-align: center;
                /* ISC-11023 deal with this. */
                /* stylelint-disable-next-line */
                -moz-appearance: textfield;
                &:focus, &:focus-within{
                    border: 2px solid ${getColor("primary")} !important;
                }
            `,
    },
}

productListStyles.container = {
    gap: 0,
        css: css`
            /* Note: below line is to prevent a weird behavior where chrome wants to print anything that will fit
            * comprehensively on a single page on that page, which means the product list appears on page 2
            when rendering a common 8-item list with no notes. That's not ideal, so we're arbitrarily making
            the component large enough that it won't fit on a single page. */
            @media print {
                padding-bottom: 120px;
            }
            border-top: 1px lightgray solid;
            overflow-anchor: none;
        `,
}

createListButtonStyles.createListButton = {
    variant: "primary",
}

headerStyles.infoGridItem = {
    width: 12,
    css: css`
        align-items: flex-end;
        >${TypographyStyle}{
            color: ${getColor("secondary")};
        }
        @media print {
            justify-content: flex-start;
            flex-direction: row !important;
        }
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    css`
                        flex-direction: column;
                    `,
                    null,
                    null,
                    css`
                        justify-content: flex-start;
                    `,
                ],
                "max",
            )}
    `,
}

wishListCardStyles.sharingStatus = {
    statusText: {
        css: css`
        color: ${getColor("secondary")};
        `
    }
}

wishListCardStyles.actionAddToCartButton = {
    variant: "primary",
    css: css`
        white-space: nowrap;
        width: 100%;
        padding: 0 10px;
    `,
}

wishListCardStyles.lastUpdatedText = {
    css: css`
    color: ${getColor("secondary")};
    `
}

searchBoxStyles.search = {
    css: css`
    padding: 12px 35px 12px 10px !important;
    &:focus{
        padding: 12px 35px 12px 10px !important;
    }
    `,
    iconProps: { src: Search },
}

listStyles.cardList = {
    gridContainer: {
        css: css`
            > ${GridOffset} {
                width: 100%;
                margin: 0;
                > div[class^="sc"] {
                    border-bottom: none;
                    border: 1px solid ${getColor("common.border")};
                    margin-bottom: 15px;
                }
            }
        `,
    },
};
paginationStyles.wrapper = {
    css: css`
        padding: 0px 0px 20px;
    `,
};
productListFilterAccordionSectionStyles.accordionSection = {
    panelProps: {
        css: css`
            overflow-y: auto;
            overflow-x: hidden;
            max-height: 350px;
        `,
    },
    titleTypographyProps: {
        css: css`
            font-size: 1rem !important;
        `,
    },
};

myListsDetailsOptionsStyles.paginationGridItem = {
    width: 12,
    css: css`
        justify-content: flex-end;
        padding-right: 0px;
    `,
}